import { IMAGES } from "@/data/content";

// BRAND LOGO — the chrome 7FCC lockup isolated on pure black. Rendered
// with mix-blend-screen so the black melts into the dark page background
// and the logo floats. The chrome stays untouched — never recolor it blue.
export default function Logo({ className = "", halo = false, priority = false }) {
  return (
    <div className={`relative inline-flex items-center justify-center mix-blend-screen ${className}`} data-testid="brand-logo">
      {halo && (
        <div
          aria-hidden="true"
          className="logo-halo absolute inset-[-24%] rounded-full blur-2xl"
        />
      )}
      <img
        src={IMAGES.logo}
        alt={IMAGES.logoAlt}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : undefined}
        draggable={false}
        className="relative w-full select-none mix-blend-screen"
      />
    </div>
  );
}
